import { IBenefitDTO } from '../../dto/benefits/benefit.dto';
import { IBenefitsDTO } from '../../dto/benefits/benefits.dto';

const benefitDTOs: IBenefitDTO[] = [
  {
    title: $localize`:@@page-avatar-downloader-content-benefits-section-option-0-title:Simple and intuitive`,
    value: $localize`:@@page-avatar-downloader-content-benefits-section-option-0-value:Our tool is built with ease of use in mind. Simply input the URL of the Instagram profile, and the rest is automatic. It's never been easier to download Instagram profile pictures.`,
  },
  {
    title: $localize`:@@page-avatar-downloader-content-benefits-section-option-1-title:No login needed`,
    value: $localize`:@@page-avatar-downloader-content-benefits-section-option-1-value:Forget about tedious registrations. You can use our service without having to create an account or log in, offering you a fully anonymous experience while downloading any Instagram profile picture.`,
  },
  {
    title: $localize`:@@page-avatar-downloader-content-benefits-section-option-2-title:Preserves image quality`,
    value: $localize`:@@page-avatar-downloader-content-benefits-section-option-2-value:When you use our tool, you get the highest possible resolution of the original profile image. Whether it's a personal or professional avatar, you'll always receive a crisp high-quality download.`,
  },
  {
    title: $localize`:@@page-avatar-downloader-content-benefits-section-option-3-title:Fast and efficient`,
    value: $localize`:@@page-avatar-downloader-content-benefits-section-option-3-value:With instant processing, you won’t be left waiting. Just a couple of clicks, and your chosen download Instagram avatar will be saved to your device immediately.`,
  },
];

export const benefitsDTO: IBenefitsDTO = {
  title: $localize`:@@page-avatar-downloader-content-benefits-section-title:Key advantages of our Instagram profile picture downloader`,
  benefits: benefitDTOs,
};
